import React, { FC, useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Form from 'react-bootstrap/cjs/Form';
import { InputGroup } from 'react-bootstrap';
import styles from './buildIdSearchInput.module.sass';

interface PropsType {
  currentBuildId: string;
  searchOnBuildId: (buildId: string) => void;
  searchVisibility: boolean;
  toggleSearchVisibility: () => void;

}

interface BuildIdSearchInputState {
  buildId: null | string;
}

const BuildIdSearchInput: FC<PropsType> = observer((props) => {

  const [BuildIdSearchInputState, setBuildId] = useState(() => ({
    buildId: props.currentBuildId
  } as BuildIdSearchInputState));

  const handleKeyPress = useCallback((event: any) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      props.searchOnBuildId(null);
    }

    if (event.key === '/') {
      event.preventDefault();
      props.toggleSearchVisibility();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);


  const updateBuildId = (buildId: string) => {
    setBuildId(
      {
        buildId: buildId
      }
    );
  };

  return (
    <Form onSubmit={(e) => {
      e.preventDefault();
      props.searchOnBuildId(BuildIdSearchInputState.buildId);
    }} className={`${styles.searchForm} ${props.searchVisibility && styles.expanded}`}>

      <InputGroup>
        <Form.Control
          type="text"
          id="buildIdSearchInput"
          placeholder={props.currentBuildId ? JSON.stringify(props.currentBuildId) : 'Search builds'}
          defaultValue={props.currentBuildId && props.currentBuildId}
          onChange={(e) => {
            updateBuildId(e.target.value);
          }}
        />
      </InputGroup>
    </Form>
  );
});

export default BuildIdSearchInput;
